import React from 'react';
import { FaWhatsapp, FaCheck } from 'react-icons/fa';
import * as S from './ProductPriceCard.styles';

/**
 * Reusable Product Price & Action Card component.
 * Explicitly avoids fake prices; uses text placeholders like "Precio próximamente" / "Consultar precio".
 */
const ProductPriceCard = ({
  statusText,
  priceText,
  priceSubtext,
  features = [],
  whatsAppUrl,
  whatsAppText = 'Consultar por WhatsApp',
  footerNote,
}) => {
  return (
    <S.CardContainer>
      {statusText && <S.StatusBadge>{statusText}</S.StatusBadge>}

      <S.PriceHeading>
        <S.PriceText>{priceText}</S.PriceText>
        {priceSubtext && <S.PriceSubtext>{priceSubtext}</S.PriceSubtext>}
      </S.PriceHeading>

      {features.length > 0 && (
        <>
          <S.Divider />
          <S.FeatureList>
            {features.map((feature, idx) => (
              <S.FeatureItem key={idx}>
                <FaCheck />
                <span>{feature}</span>
              </S.FeatureItem>
            ))}
          </S.FeatureList>
        </>
      )}

      <S.Divider />

      {whatsAppUrl && (
        <S.WhatsAppButton
          href={whatsAppUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp />
          <span>{whatsAppText}</span>
        </S.WhatsAppButton>
      )}

      {footerNote && <S.FooterNote>{footerNote}</S.FooterNote>}
    </S.CardContainer>
  );
};

export default ProductPriceCard;
